<template>
  <div class="col-4" align="center">
    <div class="circle" v-bind:style="rowStyle">
      <h1>{{student.get("name")[0]}}</h1>
    </div>
    <div class="row justify-content-center">
      <div class="col-auto pr-0">
        <!--@mouseover="$showTooltip('#starredStudent' + student.id)"
          @mouseleave="$hideTooltip('#starredStudent' + student.id)"-->
        <span
          v-if="
            user.get('starredStudents').some(
              s => s == student.id
            )
          "
          class="material-icons pointer"
          v-on:click="removeStarStudent"
          v-bind:id="'starredStudent' + student.id"
          
          data-placement="top"
          title="Remove student from starred students (appears in top of list)."
        >
          star
        </span>
        <!--@mouseover="$showTooltip('#starStudent' + student.id)"
          @mouseleave="$hideTooltip('#starStudent' + student.id)"-->
        <span
          v-else
          class="material-icons pointer"
          v-on:click="createStarStudent"
          v-bind:id="'starStudent' + student.id"
          
          data-placement="top"
          title="Add student to starred students (appears in top of list)."
        >
          star_border
        </span>
      </div>
      <div class="col-auto">
        <h5
          class="pointer d-inline-block btn-link mb-0"
          v-on:click="$emit('student-selected', student)"
        >
          <strong>{{ student.get("name") }}</strong>
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    Student: Object,
    User: Object,
  },
  data() {
    return {
      student: this.Student,
      user: this.User,
      rowStyle: {
          backgroundColor: this.stringToRBG(this.Student.get("name"))
        }
    };
  },
  methods: {
    async removeStarStudent() {
      this.$store.commit("updateLoading", true);
      var starredStudents = this.user.get("starredStudents");
      starredStudents = starredStudents.filter(s => s != this.student.id)
      this.user.set("starredStudents", starredStudents);
      await this.user.save();
      this.$emit('updated-stars')
      this.$store.commit("updateLoading", false);
    },
    async createStarStudent() {
      this.$store.commit("updateLoading", true);
      var starredStudents = this.user.get("starredStudents");
      starredStudents.push(this.student.id);
      this.$hideTooltip('#starStudent' + this.student.id)
      this.user.set("starredStudents", starredStudents);
      await this.user.save();
      this.$emit('updated-stars')
      this.$store.commit("updateLoading", false);
    },
    stringToRBG(string) {
      var hash = 0;
      if (string.length === 0) return hash;
      for (var i = 0; i < string.length; i++) {
          hash = string.charCodeAt(i) + ((hash << 5) - hash);
          hash = hash & hash;
      }
      var rgb = [0, 0, 0];
      for (var j = 0; j < 3; j++) {
          var value = (hash >> (j * 8)) & 255;
          rgb[j] = value;
      }
      return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
    }
  }
};
</script>